import { Project } from "projen/lib";
import { AgentRuleBundle } from "../agent-config-options";
import { AGENT_RULE_SCOPE } from "../types";
import { findProjectsWithFile, hasFile } from "./utils";

/**
 * TypeScript bundle — auto-detected when a tsconfig is present.
 */
export const typescriptBundle: AgentRuleBundle = {
  name: "typescript",
  description:
    "TypeScript conventions, type safety, naming, JSDoc, member ordering",
  appliesWhen: (project: Project) => hasFile(project, "tsconfig.json"),
  findApplicableProjects: (project: Project) =>
    findProjectsWithFile(project, "tsconfig.json"),
  rules: [
    {
      name: "typescript-conventions",
      description: "TypeScript coding conventions and style guide",
      scope: AGENT_RULE_SCOPE.FILE_PATTERN,
      filePatterns: ["**/*.ts", "**/*.tsx"],
      content: [
        "# TypeScript Conventions",
        "",
        "## Type Safety",
        "",
        "- Use **strict TypeScript** with all strict checks enabled",
        "- Always use explicit types; avoid `any` unless absolutely necessary",
        "- Use `readonly` for immutable properties",
        "- Prefer interfaces over types for object shapes",
        "- Use proper TypeScript types from libraries",
        "",
        "## Code Organization",
        "",
        "- Follow the member ordering rule:",
        "  1. Public static fields/methods",
        "  2. Protected static fields/methods",
        "  3. Private static fields/methods",
        "  4. Instance fields",
        "  5. Constructor",
        "  6. Methods",
        "",
        "## Documentation",
        "",
        "- **Keep JSDoc minimal** so that the code remains human-readable. Use brief summaries only.",
        "- Use JSDoc for:",
        "  - Public classes and interfaces (short description)",
        "  - Public methods and properties (brief purpose; parameter and return when not obvious)",
        "  - Configuration options (one-line description)",
        "- **Extended documentation** belongs in **markdown** files. Link from JSDoc via `@see` or an inline link.",
        "",
        "## Naming Conventions",
        "",
        "- **Classes**: PascalCase (e.g., `TypeScriptProject`, `StaticHosting`)",
        "- **Interfaces**: PascalCase, often with `Props` suffix for configuration (e.g., `StaticHostingProps`)",
        "- **Functions/Methods**: camelCase (e.g., `configureProject`)",
        "- **Constants**: UPPER_SNAKE_CASE (e.g., `VERSION`, `AWS_STAGE_TYPE`)",
        "- **Files**: kebab-case for multi-word files (e.g., `aws-deployment-config.ts`)",
        "- **Component file naming**: kebab-case filename must mirror the PascalCase class name (e.g., `ResetTask` → `reset-task.ts`)",
        "- **Private members**: No prefix needed (TypeScript handles visibility)",
        "",
        "## Array Type Syntax",
        "",
        "- Prefer `Array<T>` over `T[]` for readability",
        "- For nested generics this is especially important: `Array<Array<string>>` is clearer than `string[][]`",
        "",
        "## Enum Preference",
        "",
        "- Prefer `as const` objects over TypeScript `enum` declarations",
        "- `as const` objects are more flexible: they support computed values, work with `keyof typeof`, and tree-shake better",
        "- Example:",
        "  ```typescript",
        "  // Prefer this:",
        "  const Status = { Active: 'active', Inactive: 'inactive' } as const;",
        "  type Status = (typeof Status)[keyof typeof Status];",
        "",
        "  // Over this:",
        "  enum Status { Active = 'active', Inactive = 'inactive' }",
        "  ```",
      ].join("\n"),
      tags: ["coding"],
    },
  ],
  claudePermissions: {
    allow: ["Bash(npx tsc:*)"],
  },
};
